import type { ChatMessage } from '@sw/protocol';
import { create } from 'zustand';

interface ChatState {
  messages: ChatMessage[];
  open: boolean;
  unread: number;
  /** Últimos emotes por usuario (para burbujas sobre los jugadores). */
  bubbles: Record<string, { emote: string; at: number }>;
  setHistory(m: ChatMessage[]): void;
  push(m: ChatMessage): void;
  setOpen(open: boolean): void;
}

export const useChat = create<ChatState>((set) => ({
  messages: [],
  open: false,
  unread: 0,
  bubbles: {},
  setHistory(messages) {
    set({ messages, unread: 0 });
  },
  push(m) {
    set((s) => {
      if (s.messages.some((x) => x.id === m.id)) return s;
      const messages = [...s.messages, m].slice(-150);
      const bubbles = m.kind === 'emote' ? { ...s.bubbles, [m.userId]: { emote: m.emote, at: Date.now() } } : s.bubbles;
      const unread = s.open || m.kind === 'system' ? s.unread : s.unread + 1;
      return { messages, bubbles, unread };
    });
  },
  setOpen(open) {
    set({ open, ...(open ? { unread: 0 } : {}) });
  },
}));
